import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { Col, Row, Button, Form, InputGroup, Table } from "react-bootstrap";
import MyNavbarInner from "../component/navbarinner";
import { getReferralList, getUserInfo } from "../ApiAction/api";
import moment from "moment";
import { Roller } from "react-awesome-spinners";
import { Link, useNavigate } from "react-router-dom";
import config from "../config/config";
import { toastAlert } from "../helper/toastAlert";
import isEmpty from "is-empty"
import { walletValidate, walletInputValidate } from "../validation/validation"
import { UpdateWallet } from "../ApiAction/api"
import MyNavbar from "../component/navbar";

export default function Referral_page() {
  var navigate = useNavigate();

  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [loader, setloader] = useState(true);
  const [user, setUser] = useState({});
  const [userinfo, setUserinfo] = useState({});
  const [filter, setFilter] = useState({ skip: 1, limit: 10 });
  const [copied, setCopied] = useState(false);
  const [kycstatus, setkycstatus] = useState("");
  const [walletData, setWalletData] = useState({ wallet: "" });
  const [error, setError] = useState({});
  const [isload, setisLoad] = useState(false);
  const [loading, setLoading] = useState(true);


  let { wallet } = walletData

  const handleChange = (e) => {
    const { name, value, } = e.target;
    const next = { ...walletData, [name]: value };
    setWalletData(next);
    const errMsg = walletInputValidate(next, name);
    setError({ ...error, ...errMsg });
  };


  let handleClick = async () => {
    try {
      let errMsg = await walletValidate(walletData);
      setError(errMsg);
      if (isEmpty(errMsg)) {
        setisLoad(true);
        let { status, message } = await UpdateWallet(walletData);
        console.log(status, message, "status, message");
        if (status == true) {
          setisLoad(false);
          toastAlert("success", message, "register");
          setWalletData({ wallet: "" });
          setTimeout(() => {
            window.location.reload();
          }, 100);
        } else if (message) {
          setisLoad(false);
          toastAlert("error", message, "register");
          setWalletData({ wallet: "" });
          return;
        } else {
          setisLoad(false);
          setWalletData({ wallet: "" });
        }
      }
    } catch (err) {
      console.log(err, "errr");
    }
  };

  const getData = async () => {

    try {
      let { userData, totalrecords, result, status, isKyc } =
        await getReferralList(filter);
      if (status === true) {
        setkycstatus(isKyc);
        setUser(userData);
        setCount(totalrecords);
        setData(result);
      }
    } catch (err) {
      console.error("Error fetching referral data", err);
    }
    setloader(false);
  };

  useEffect(() => {
    userData();
    getData();
  }, [filter]);

  useEffect(() => {
    userData()
  }, [])

  const handleNext = () => {
    setFilter((prev) => ({ ...prev, skip: prev.skip + 1 }));
  };

  const handlePrevious = () => {
    setFilter((prev) => ({ ...prev, skip: prev.skip - 1 }));
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(
      `${user?.encryptuserId}`
    );
    setCopied(true);

    setTimeout(() => setCopied(false), 2000);
  };

  function checkKyc() {
    console.log(kycstatus, 'kycstatuskycstatus')
    if (kycstatus == "approved") {
      console.log(kycstatus, 'kycstatuskycstatus21111')
      //navigate("/buytoken");
      window.location.href = "/buytoken"
    } else {
      toastAlert("error", "Please verify your kyc details", "forget");
    }
  }
  const userData = async () => {
    const { result, status } = await getUserInfo()
    console.log('result :', result);
    if (status) {
      setUserinfo(result)
    } else {
      setUserinfo({})
    }
    setLoading(false);
  }

  useEffect(() => {
    if (loading || !isEmpty(userinfo.wallet)) return;

    const modalElement = document.getElementById("WalletModal");
    if (!modalElement) return;

    const bootstrap = window.bootstrap || require("bootstrap/dist/js/bootstrap.bundle.min.js");
    const existingModal = bootstrap.Modal.getInstance(modalElement);

    const walletModal = new bootstrap.Modal(modalElement, {
      backdrop: "static",
      keyboard: false,
    });

    const timer = setTimeout(() => {
      walletModal.show();
    }, 100);

    return () => clearTimeout(timer);
  }, [userinfo.wallet, loading]);

  return (
    <>
      <MyNavbarInner />
      {/* <MyNavbar /> */}

      <section>
        <Container>
          {kycstatus == "approved" && !loader && (
            <div className="d-flex justify-content-center">
              <div class="alert alert-success alert_text " role="alert">
                <img
                  src={require("../assets/images/completed_icon.png")}
                  alt="Remove"
                  className="img-fluid me-3"
                  style={{ cursor: "pointer" }}
                />
                Your KYC is completed.
              </div>
            </div>
          )}
          {/* {kycstatus != "approved" && !loader && (
            <div className="d-flex justify-content-center">
              <div class="alert alert-danger alert_text" role="alert">
                <img
                  src={require("../assets/images/info_icon.png")}
                  alt="Remove"
                  className="img-fluid me-3"
                  style={{ cursor: "pointer" }}
                />
                Your KYC is not complete.
              </div>
            </div>
          )} */}
          {loader ? (
            <div className="text-center">
              <Roller className="loading mx-auto" color="white" />
            </div>
          ) : (
            <div className="referral_page">
              <Row className="justify-content-center">
                <Col xl="10" md="12">
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <p className="join_head mb-0">Dashboard</p>
                    <div>
                      {kycstatus == "approved" ?
                        <a
                          href="/buytoken"
                          className="primary_btn me-3"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Buy Token
                        </a> :
                        <Link
                          className="primary_btn me-3"
                          to="/buytoken"
                        // onClick={() => checkKyc()}
                        >
                          Buy Token
                        </Link>}
                      <Link to="/kyc" className="primary_btn ">
                        KYC
                      </Link>
                    </div>
                  </div>
                  <div className="reg_form referral_page_head">
                    <div>
                      <Form.Label
                        className="input_join"
                        htmlFor="inputPassword5"
                      >
                        Your Referral Link
                      </Form.Label>
                      <InputGroup className="input_group_box">
                        <Form.Control
                          placeholder={`${user?.encryptuserId}`}
                          aria-label="Referral Link"
                          aria-describedby="basic-addon1"
                          readOnly
                        />
                        <InputGroup.Text
                          id="basic-addon1"
                          onClick={handleCopy}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={require("../assets/images/copy_icon.png")}
                            alt="Copy"
                            className="img-fluid ms-2"
                            width={20}
                            height={20}
                          />
                        </InputGroup.Text>
                      </InputGroup>
                      {copied && (
                        <p style={{ color: "pink", marginTop: "5px" }}>
                          Copied!
                        </p>
                      )}
                    </div>

                    <div className="sec_2 referral_page_sec_2">
                      <div>
                        <p>REFERRAL TOKEN BALANCE</p>
                        <h6 className="mb-0">
                          {user?.wintoken ? user?.wintoken : 0}
                        </h6>
                      </div>
                    </div>
                    <div className="sec_2 referral_page_sec_2">
                      <img
                        src={require("../assets/images/user_icon.png")}
                        alt="User"
                        className="img-fluid"
                        width={20}
                        height={20}
                      />
                      <div>
                        <p>TOTAL REFERRALS</p>
                        <h6 className="mb-0">{count}</h6>
                      </div>
                    </div>
                  </div>
                  <Form.Label className="input_join" htmlFor="inputPassword5">
                    Referral History
                  </Form.Label>
                  <Table responsive className="referral_table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>DATE</th>
                        <th>Referral Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            {moment(item.createdAt).format("DD-MM-YYYY hh:mm")}
                          </td>
                          <td>{item.name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                    }}
                  >
                    <Button
                      onClick={handlePrevious}
                      disabled={filter.skip === 0}
                      style={{
                        backgroundColor: "rgb(49, 30, 48)",
                        borderColor: "rgb(49, 30, 48)",
                      }}
                    >
                      Previous
                    </Button>
                    <Button
                      onClick={handleNext}
                      disabled={filter.skip + filter.limit >= count}
                      style={{
                        backgroundColor: "rgb(49, 30, 48)",
                        borderColor: "rgb(49, 30, 48)",
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Container>
      </section >
      {/* Wallet Modal */}
      <div
        class="modal fade model_box"
        id="WalletModal"
        tabindex="-1"
        aria-labelledby="WalletModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="WalletModalLabel">
                Update Wallet Address
              </h1>
              {/* <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button> */}
            </div>
            <div class="modal-body">
              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <Form.Label className="input_join">
                    Wallet Address:
                  </Form.Label>
                </div>
                <InputGroup className="input_group_box">
                  <Form.Control
                    placeholder="Enter Wallet Address"
                    aria-label="Wallet Address"
                    aria-describedby="basic-addon1"
                    name="wallet"
                    value={wallet}
                    onChange={handleChange}
                  />

                </InputGroup>
                {error && error.wallet && (
                  <span style={{ color: "red" }}>{error.wallet}</span>
                )}
              </div>
              <div className="text-center mt-4">
                <button className="primary_btn" onClick={handleClick}>Submit {isload && <i className="fas fa-spinner fa-spin"></i>}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
